import { RoundHistory } from "../type";

export type Response<T> = {
  ok: boolean;
  data?: T;
};

const { REACT_APP_SLOT_GAME_API_URL = "" } = process.env;

const ApiService = {
  async getRoundHistoryByRoundId(
    gameCode: string,
    roundId: string
  ): Promise<Response<RoundHistory>> {
    const uri = new URL(`/api/rounds/${roundId}`, REACT_APP_SLOT_GAME_API_URL);
    const res = await fetch(uri, {
      method: "GET",
      headers: {
        "Game-identifier": gameCode,
      },
    });
    if (res.ok) return { ok: true, data: await res.json() };
    return { ok: false };
  },
  async getRoundHistoryBySpinId(
    gameCode: string,
    spinId: string
  ): Promise<Response<RoundHistory>> {
    const uri = new URL(`/api/spins/${spinId}`, REACT_APP_SLOT_GAME_API_URL);
    const res = await fetch(uri, {
      method: "GET",
      headers: {
        "Game-identifier": gameCode,
      },
    });
    if (res.ok) return { ok: true, data: await res.json() };
    return { ok: false };
  },
  async getRule(gameCode: string): Promise<Response<Record<string, unknown>>> {
    const uri = new URL(`/api/game-info/rule`, REACT_APP_SLOT_GAME_API_URL);
    const res = await fetch(uri, {
      method: "GET",
      headers: {
        "Game-identifier": gameCode,
      },
    });
    if (res.ok) return { ok: true, data: await res.json() };
    return { ok: false };
  },
  async getSetting(
    gameCode: string
  ): Promise<Response<Record<string, unknown>>> {
    const uri = new URL(`/api/game-info/setting`, REACT_APP_SLOT_GAME_API_URL);
    const res = await fetch(uri, {
      method: "GET",
      headers: {
        "Game-identifier": gameCode,
      },
    });
    if (res.ok) return { ok: true, data: await res.json() };
    return { ok: false };
  },
} as const;

export default ApiService;
